import { gql } from "@apollo/client";

import { lensFragment } from "../../../shared/api/fragments";

export const setLensPreview = gql`
    mutation setLensPreview($lensId: ID!, $lensPreview: Upload) {
        setLensPreview(input: { lensId: $lensId, lensPreview: $lensPreview }) {
            lens {
                ...Lens
            }
        }
    }
    ${lensFragment}
`;
